import { render, staticRenderFns } from "./AcknowledgementWidget.vue?vue&type=template&id=9d0d7b3a&scoped=true&"
import script from "./AcknowledgementWidget.vue?vue&type=script&lang=js&"
export * from "./AcknowledgementWidget.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgementWidget.vue?vue&type=style&index=0&id=9d0d7b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0d7b3a",
  null
  
)

export default component.exports